// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YOxFm","footer":"styles_footer__xMDlo","spacer":"styles_spacer__TDqx6"};